import { createContext, useContext, useState } from "react";

const HeaderTitleContext = createContext();

export const HeaderTitleProvider = ({ children }) => {
  const [headerTitle, setHeaderTitle] = useState("");

  return (
    <HeaderTitleContext.Provider value={{ headerTitle, setHeaderTitle }}>
      {children}
    </HeaderTitleContext.Provider>
  );
};

export const useHeaderTitle = () => {
  return useContext(HeaderTitleContext);
};
